import { SelectContentProps } from 'components/ui/Forms';
import { CargoType } from 'contracts/CargoTypes';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

export function useCargoType() {
  const { token } = useAuth();
  const getCargoTypes = async (): Promise<SelectContentProps[]> => {
    const { data } = await api.get(`/cargo-types?asList=1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map((cargoType: CargoType) => ({
      value: cargoType.id,
      name: cargoType.name,
    }));
  };

  return { getCargoTypes };
}
